import type { HttpClient, RawSessionCustomer, SessionCustomer } from '@cld/session-service';
import { fetchClient, API_ORIGIN } from '@cld/session-service';
import { AppId } from '../../ApplicationWrapper.types';
import { getSerializedCustomersList } from './utils';

const getProductQueryParam = (appId?: AppId): string => {
  if (!appId || appId === AppId.Settings || appId === AppId.MediaFlows) {
    return '';
  }

  if (appId === AppId.Video) {
    return AppId.MediaAPI;
  }

  return appId;
};

const getCustomersUrl = (appId?: AppId, sortBy?: string) => {
  const sort = sortBy ? `&sort_by=${sortBy}` : '';
  const productQueryParam = getProductQueryParam(appId);
  return `${API_ORIGIN}/console/api/v1/customers?per_page=50${sort}${productQueryParam ? `&product=${productQueryParam}` : ''}`;
};

export const createFetchCustomersList =
  (httpClient: HttpClient<{ data: RawSessionCustomer[] }>, appId?: AppId) =>
  (searchTerm = ''): Promise<SessionCustomer[]> => {
    // FIXME: workaround to use all of PM clouds as video clouds
    const fields = [
      'id',
      'name',
      'cloud_name',
      'created_at',
      'display_name',
      'external_id',
      'account_id',
      'product_name',
      'provisioning_status',
      'status',
    ];
    const onlyParam = encodeURIComponent(JSON.stringify({ customer: fields }));
    const url = `${getCustomersUrl(appId, 'display_name')}&only=${onlyParam}&name_contains=${encodeURIComponent(searchTerm)}`;
    return httpClient(url)
      .then((res) => res.data)
      .then(getSerializedCustomersList);
  };

export const generateFetchCustomerListForAppId = (appId?: AppId) => createFetchCustomersList(fetchClient, appId);
